const startTyping = axios => {
  return axios.post('typing');
};

const stopTyping = axios => {
  return axios.put('typing');
};

export { startTyping, stopTyping };
